import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
export default function Skill() {
  const [doc, setDoc] = useState<any>(null); const [err, setErr] = useState('');
  useEffect(() => { (async () => { try { const r = await fetch('/api/trading/skill'); const d = await r.json(); if (!r.ok) throw new Error(d.error || 'Failed'); setDoc(d); } catch (e: any) { setErr(e.message); } })(); }, []);
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100">
      <main className="mx-auto max-w-3xl px-3 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-bold">Trading skill</h1>
          <Link to="/" className="text-sm text-zinc-400 underline">Console</Link>
        </div>
        {doc && <div className="mt-1 text-xs text-zinc-400">v{doc.version} · {doc.updated}{doc.status ? ` · ${doc.status}` : ''}</div>}
        {err && <div className="mt-3 text-sm text-red-400">{err}</div>}
        {doc && <pre className="mt-3 whitespace-pre-wrap break-words font-mono text-[13px] leading-relaxed text-zinc-200">{doc.content}</pre>}
      </main>
    </div>
  );
}
